import { render } from "./CookiesPage.vue?vue&type=template&id=0982a4b8"
import script from "./CookiesPage.vue?vue&type=script&lang=js"
export * from "./CookiesPage.vue?vue&type=script&lang=js"
script.render = render

export default script